import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { SharedModule } from 'src/app/modules/shared/shared.module';
import { IndexCompnent } from './index.component';
import { VideoDialogComponent } from './components/video-dialog/video-dialog.component'
import {MatTabsModule} from '@angular/material/tabs';
import { YouTubePlayerModule } from '@angular/youtube-player';
import { CountUpModule } from 'ngx-countup';
import { MatDialogModule } from '@angular/material/dialog';



const routes: Routes = [
  { path: '', component: IndexCompnent},
];


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule.forChild(routes),
    MatTabsModule,
    YouTubePlayerModule,
    CountUpModule,
    MatDialogModule,
  ],
  declarations: [
    IndexCompnent,
    VideoDialogComponent,
  ],

})
export class IndexModule { }
